const SUPPORT_EMAIL = 'studiosupport@klydoclock.com';

const useContactSupport = () => {
  const openSupport = () => {
    window.location.href = `mailto:${SUPPORT_EMAIL}`;
  };

  return { openSupport, supportEmail: SUPPORT_EMAIL };
};

export default useContactSupport;
